

    <div class="sufee-login d-flex align-content-center flex-wrap">
        <div class="container">
            <div class="login-content">
                
                <div class="login-form">
                <div class="login-logo">
                    <a href="index.html">
                        <img class="align-content" src="assets/images/gic-header-logo.png" alt="">
                    </a>
                </div>
                    <form name="login">
                  
                        <div class="form-group">
                            <label>User ID</label>
                            <input type="username" class="form-control" placeholder="User ID" name="username" [(ngModel)]="username">
                            <span style="font-size: 10px; color: red;" *ngIf="isErr" id="isErr">{{errMsg}}</span>
                        </div>                        
                        <button type="submit" class="btn btn-success btn-flat m-b-30 m-t-30 loginbtn" (click)="forgotPsw()">Send</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
  
   
     
    <!--<script src="https://cdn.jsdelivr.net/npm/jquery@2.2.4/dist/jquery.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/popper.js@1.14.4/dist/umd/popper.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.1.3/dist/js/bootstrap.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/jquery-match-height@0.7.2/dist/jquery.matchHeight.min.js"></script>
    <script src="assets/js/main.js"></script>-->
   

